import StateWidgetContainer from './StateWidgetContainer';
import IWidgetProps from './IWidgetProps';

export default StateWidgetContainer;

export {
    StateWidgetContainer,
    IWidgetProps,
}


// WEBPACK FOOTER //
// ./src/components/widget/StateWidgetContainer/index.tsx